import List from "@/components/list";
import route from "@/router";

const Table = args => {
  const AccountTableConfig = [
    {
      label: "消息内容",
      prop: "mqTemplateContent",
      minWidth: "300",
      // showOverflowTooltip: true
      render: vo => (
        <div class="text-two-line" title={vo.row.mqTemplateContent}>
          {vo.row.mqTemplateContent}
        </div>
      )
    },
    {
      label: "发送数量",
      prop: "sendCount"
    },
    {
      label: "发送中",
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            route.push({
              path: "/bizMessage/sended",
              query: { mqTemplateId: vo.row.mqTemplateId }
            });
          }}
        >
          {vo.row.sendGoingCount}
        </el-button>
      )
    },
    {
      label: "发送成功",
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            route.push({
              path: "/bizMessage/success",
              query: { mqTemplateId: vo.row.mqTemplateId }
            });
          }}
        >
          {vo.row.sendSuccessCount}
        </el-button>
      )
    },
    {
      label: "发送失败",
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            route.push({
              path: "/bizMessage/failure",
              query: { mqTemplateId: vo.row.mqTemplateId }
            });
          }}
        >
          {vo.row.sendFailCount}
        </el-button>
      )
    },
    {
      label: "回复数",
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            route.push({
              path: "/bizMessage/reply",
              query: {
                mqTemplateId: vo.row.mqTemplateId
              }
            });
          }}
        >
          {vo.row.replyCount}
        </el-button>
      )
    },
    {
      label: "发送人",
      prop: "sendUserName"
    },
    {
      label: "发送时间",
      prop: "smsSendDate"
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};

export default Table;
